import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState
  } from 'react';
import { useLocation } from 'react-router-dom';

interface ElementController {
  sideMenuRef: React.RefObject<HTMLTdsSideMenuElement | null>;
  enableSidebar: boolean;
  setEnableSidebar: React.Dispatch<React.SetStateAction<boolean>>;
  toggleMobileNav: () => void;
}

const ElementControllerContext = createContext<ElementController | null>(null);

export const ElementControllerProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();

  const [enableSidebar, setEnableSidebar] = useState(true);
  const sideMenuRef = useRef<HTMLTdsSideMenuElement>(null);

  const toggleMobileNav = useCallback(() => {
    if (sideMenuRef.current) {
      sideMenuRef.current.open = !sideMenuRef.current.open;
    }
  }, [sideMenuRef]);

  useEffect(() => {
    if (sideMenuRef.current) {
      sideMenuRef.current.open = false;
    }
  }, [location, sideMenuRef]);

  const value = useMemo(
    () => ({
      sideMenuRef,
      enableSidebar,
      setEnableSidebar,
      toggleMobileNav,
    }),
    [sideMenuRef, enableSidebar, setEnableSidebar, toggleMobileNav],
  );

  return <ElementControllerContext.Provider value={value}>{children}</ElementControllerContext.Provider>;
};

export const useElementController = () => useContext(ElementControllerContext);
